/* Copyright (C) 2023 Advenio Tecnosys Pvt. Ltd.

*        All Rights Reserved

*

 * NOTICE: 

 * All information contained herein is, and remains

* the property of Advenio Tecnosys and its suppliers,

* if any.  The intellectual and technical concepts contained

* herein are proprietary to Advenio Tecnosys

* and its suppliers and may be covered by Indian, U.S. and Foreign Patents,

* patents in process, and are protected by trade secret or copyright law.

* Appropriation, redistribution, dissemination of this information or reproduction

* of this material is strictly forbidden unless prior written permission is obtained

* from Advenio Tecnosys Pvt. Ltd.

*

* Author: < codebhendi, Ravi Ranjan Kumar, Sanket, Mylavarapu Sarath Sai, Amal Sabu, Ujjwal Singh >

*/


const defaultState = {
  createPatientFormData: {},
  createBasicDetailsFormData: {
    countryCode: "IN(+91)",
    // disabling the dob to use age instead.
    // dob: new Date(),
    age: 1,
    firstName: "",
    lastName: "",
    middleName: "",
    gender: "M",
    email: "",
  },
  createSymtomsFormData: { ocular: [], systemic: [] },
  createPersonalDetailsStatsFormData: { height: "", weight: "" },
  createPersonalDetailsContactsFormData: {
    emgCountryCode: "IN(+91)",
    address: "",
    city: "",
    mobileNo: "",
    pinCode: "",
    state: "",
  },
  createPatientMedicalHistoryFormData: {
    KnownAllergies: "None",
    otherMedical: "NA",
  },
  createFamilyMedicalHistoryFormData: [],
  createBloodGlucoseFormData: {},
  createBloodPressureFormData: {},
  createGenBloodTestFormData: {},
  createLipidProfileFormData: {},
  createRenalFunctionFormData: {},
  bloodGlucoseDetails: [],
  bloodPressureDetail: [],
  bloodGenTestDetail: [],
  lipidProfileDetail: [],
  renalFunctionDetail: [],
  patientsList: [],
  selectedPatientList: [],
  createLifeStyleFormData: {},
  createRetinalImagesFormData: {},
  patientsDataById: {},
  addPatientRes: "",
  syncPatientDataRes: "",
  saveOrUpdateBtn: true,
  reportCountAlert: null,
  isRegisteredResponse: false,
  activeRealtimePatientMrn: null,
  pendingRealtimePatientMrn: null,
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case "GET_PATIENTS_LIST_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }

    case "GET_PATIENTS_LIST_FULFILLED": {
      // console.log("patient's list", action.payload.data);
      return {
        ...state,
        patientsList: action.payload.data,
        // patientListByServer:action.payload.
        loading: false,
        errors: {},
      };
    }
    case "GET_PATIENT_DATA_BY_ID_FULFILLED": {
      return {
        ...state,
        patientsDataById: action.payload.data,
        loading: false,
        errors: {},
      };
    }
    case "GET_PATIENTS_LIST_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload.message },
      };
    }
    // online sync data
    case "SYNC_PATIENT_DATA_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }

    case "SYNC_PATIENT_DATA_FULFILLED": {
      return {
        ...state,
        syncPatientDataRes: action.payload.data,
        loading: false,
        errors: {},
      };
    }

    case "SYNC_PATIENT_DATA_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload.message },
      };
    }
    case "ADD_PATIENT_DATA_PENDING": {
      return {
        ...state,
        loading: true,
        errors: {},
      };
    }

    case "ADD_PATIENT_DATA_FULFILLED": {
      return {
        ...state,
        addPatientRes: action.payload,
        loading: false,
        // errors: action.payload.errors
      };
    }

    case "ADD_PATIENT_DATA_REJECTED": {
      return {
        ...state,
        loading: false,
        errors: { global: action.payload.data.message },
      };
    }
    // store
    case "SAVE_OR_UPDATE_PATIENT_BTN_FULFILLED": {
      return {
        ...state,
        saveOrUpdateBtn: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "CREATE_PATIEN_FORMDATA_FULFILLED": {
      return {
        ...state,
        createPatientFormData: {
          ...state.createPatientFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_BASIC_DETAILS_FORMDATA_FULFILLED": {
      return {
        ...state,
        createBasicDetailsFormData: {
          ...state.createBasicDetailsFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "IS_REGISTERED_RESPONSE_FULFILLED": {
      return {
        ...state,
        isRegisteredResponse: action.payload.message,
        isRegisteredResponseError: action.payload.error,
      };
    }
    case "CREATE_SYMTOMS_FORMDATA_FULFILLED": {
      return {
        ...state,
        createSymtomsFormData: {
          ...state.createSymtomsFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_PERSONAL_DETAILS_STATS_FORMDATA__FULFILLED": {
      return {
        ...state,
        createPersonalDetailsStatsFormData: {
          ...state.createPersonalDetailsStatsFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_PERSONAL_DETAILS_CONTACTS_FORMDATA_FULFILLED": {
      return {
        ...state,
        createPersonalDetailsContactsFormData: {
          ...state.createPersonalDetailsContactsFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_PATIENT_MEDICAL_HISTORY_FORMDATA_FULFILLED": {
      return {
        ...state,
        createPatientMedicalHistoryFormData: {
          ...state.createPatientMedicalHistoryFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_FAMILY_MEDICAL_HISTORY_FORMDATA_FULFILLED": {
      return {
        ...state,
        createFamilyMedicalHistoryFormData: action.payload.value,
        loading: false,
        errors: {},
      };
    }
    case "CREATE_BLOOD_GLUCOSE_FORMDATA_FULFILLED": {
      return {
        ...state,
        createBloodGlucoseFormData: {
          ...state.createBloodGlucoseFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_BLOOD_PRESSURE_FORMDATA_FULFILLED": {
      return {
        ...state,
        createBloodPressureFormData: {
          ...state.createBloodPressureFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_GEN_BLOOD_TEST_FORMDATA_FULFILLED": {
      return {
        ...state,
        createGenBloodTestFormData: {
          ...state.createGenBloodTestFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_LIPID_PROFILE_FORMDATA_FULFILLED": {
      return {
        ...state,
        createLipidProfileFormData: {
          ...state.createLipidProfileFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_RENAL_FUNCTION_FORMDATA_FULFILLED": {
      return {
        ...state,
        createRenalFunctionFormData: {
          ...state.createRenalFunctionFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_LIFE_STYLE_FORMDATA_FULFILLED": {
      return {
        ...state,
        createLifeStyleFormData: {
          ...state.createLifeStyleFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "CREATE_RETINAL_IMAGES_FORMDATA_FULFILLED": {
      return {
        ...state,
        createRetinalImagesFormData: {
          ...state.createRetinalImagesFormData,
          [action.payload.field]: action.payload.value,
        },
        loading: false,
        errors: {},
      };
    }
    case "ADD_CREATE_PATIENT_FORMDATA_FULFILLED": {
      return defaultState;
    }
    case "UPDATE_CREATE_PATIENT_FORMDATA_FULFILLED": {
      return {
        ...state,
        createBasicDetailsFormData:
          action.payload.registrationData.basicDetails,
        createSymtomsFormData: action.payload.registrationData.symtomsDetails,
        createPersonalDetailsStatsFormData:
          action.payload.personalData.personalStatsDetails,
        createPersonalDetailsContactsFormData:
          action.payload.personalData.personalContactsDetails,
        createPatientMedicalHistoryFormData:
          action.payload.patientHistoryData.patientMedicalHistoryDetails,
        createFamilyMedicalHistoryFormData:
          action.payload.patientHistoryData.familyMedicalHistoryDetails,
        bloodGlucoseDetails:
          action.payload.clinicalConditionData.bloodGlucoseDetails,
        bloodPressureDetail:
          action.payload.clinicalConditionData.bloodPressureDetail,
        bloodGenTestDetail:
          action.payload.clinicalConditionData.bloodGenTestDetail,
        lipidProfileDetail:
          action.payload.clinicalConditionData.lipidProfileDetail,
        renalFunctionDetail:
          action.payload.clinicalConditionData.renalFunctionDetail,
        createBloodGlucoseFormData:
          action.payload.clinicalConditionData.bloodGlucoseDetails[0],
        createBloodPressureFormData:
          action.payload.clinicalConditionData.bloodPressureDetail[0],
        createGenBloodTestFormData:
          action.payload.clinicalConditionData.bloodGenTestDetail[0],
        createLipidProfileFormData:
          action.payload.clinicalConditionData.lipidProfileDetail[0],
        createRenalFunctionFormData:
          action.payload.clinicalConditionData.renalFunctionDetail[0],
        createLifeStyleFormData: action.payload.lifeStyleData.lifeStyleDetail,
        createRetinalImagesFormData:
          action.payload.retinalImagesData.retinalImagesDetails,
        loading: false,
        patientsDataById: { mrn: action.payload?.mrn },
        errors: {},
      };
    }
    case "UPDATE_PATIENT_LIST": {
      return {
        ...state,
        patientsList: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "SELECTED_PATIENT_LIST_DATA": {
      return {
        ...state,
        selectedPatientList: action.payload,
        loading: false,
        errors: {},
      };
    }
    case "TRIGGER_PATIENT_REPORT_COUNT_ALERT": {
      return {
        ...state,
        reportCountAlert: action.payload,
      };
    }
    case "UPDATE_PATIENT_DATA_BY_ID": {
      return {
        ...state,
        patientsDataById: action.payload,
      };
    }
    case "SET_ACTIVE_PATIENT_REALTIME_MRN": {
      return {
        ...state,
        activeRealtimePatientMrn: action.payload,
        pendingRealtimePatientMrn: null,
      };
    }
    case "SET_PENDING_PATIENT_REALTIME_MRN": {
      return {
        ...state,
        pendingRealtimePatientMrn: action.payload,
      };
    }

    default:
      return state;
  }
  return state;
};
